import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../app.service';
import { AttachFileDialogComponent } from '../../document-in-library/attach-file-dialog/attach-file-dialog.component';
import { GETModels, PIPDetailsVM, PIPStatusVM, PIPSupportDocVM, PIPSupportProgramLevelsVM } from '../../GET_NEW_UI/entities/global/model';
import { DocumentLibraryService } from '../../GET_NEW_UI/services/document-library.service';
import { ProgramImprovementService } from '../../GET_NEW_UI/services/program-improvement.service';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-product-improvement-program',
  templateUrl: './product-improvement-program.component.html',
  styleUrls: ['./product-improvement-program.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class ProductImprovementProgramComponent implements OnInit {

  constructor( private _appService: AppService,  private _documentLibraryService:DocumentLibraryService,
    public dialog: MatDialog,
    private _programImprovementService :ProgramImprovementService, private _router:Router,
    private _notify: NotificationsService,   private _route: ActivatedRoute,) { }

  ProductProgramId: number = 0;
  NewProductProgramId: number = 0;
  attachmentList:PIPSupportDocVM[]=[]
  modelList:GETModels[]=[]
  PIPStatusList:PIPStatusVM[]=[]
  PIPsupportLevelList:PIPSupportProgramLevelsVM[]=[]

  Selectmodel:number[]=[];
  Selectmodel_=[]
  serialStart:string=""
  serialEnd:string=""
  PIPNumber:string=""
  PIPHeading:string=""
  PIPDescription:string=""
  startDate:Date=null
  endDate:Date=null
  supportProgramAssociateLevel:number=0
  supportProgramNotes:string=""
  selectStatus:number=0

  NewFileName: string = "";
  FilePreview: string = "";
  Extension:string="";

  isSelectAll:boolean=false
  showGenerateButton:boolean=false
  showGenerateButton_:boolean=false
  isSavedEnable:boolean=true

  ngOnInit() {
    this._appService.setPageTitle('Product Improvement Program');
    this.ProductProgramId = +this._route.snapshot.paramMap.get('ProductProgramId');
    this.getGETModels();
    this.getPIPStatus();
    this.getPIPSupportLevels();

    if(this.ProductProgramId>0){
      this._programImprovementService.getSearcheProgImpInfromation(this.ProductProgramId).subscribe(res=>{    
        this.Selectmodel=res.ModelId;   
     this.serialStart=res.SerialStart;
     this.serialEnd=res.SerialEnd;
     this.PIPNumber=res.PIPNo;
     this.PIPHeading=res.PIPHeading;
     this.PIPDescription=res.PIPDescription;
     this.startDate=res.StartDate;
     this.endDate=res.EndDate;
     this.supportProgramAssociateLevel=res.supportProgramLevelId;
     this.supportProgramNotes=res.supportProgramNote;  
     this.selectStatus=res.PIPStatusID
     this.Selectmodel_=res.ModelId;
     this.showGenerateButton_=true
 
      })

    // load attachments
    this._programImprovementService.getSupportDocforProductProg(this.ProductProgramId).subscribe(res=>{
      console.log("attschments", res)
      this.attachmentList=res
          })
    }
  

  }

  getGETModels()
  {
    this._documentLibraryService.GetGETModelList().subscribe(res=>{
    this.modelList=res
    })
  }

  getPIPStatus(){
   this._programImprovementService.getPIPStatus().subscribe(res=>{
   this.PIPStatusList=res
   
   })
  }

  getPIPSupportLevels(){
    this._programImprovementService.getPIPSupportLevel().subscribe(res=>{
      this.PIPsupportLevelList=res
      console.log(this.PIPsupportLevelList)
    })
  }
  openAttachDoc()
  {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
      data: { NewFileName:this.NewFileName,

              FilePreview:this.FilePreview
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log("res",res)
      if (res !=false) {
        this.FilePreview=res.FilePreview; 
        this.NewFileName=res.NewFileName;
        this.Extension=res.Extension;
        
        let obj = {
         
          Id: null,      
          PIPId:this.ProductProgramId,      
          attachment_:this.FilePreview,
          FileName:this.NewFileName,
          Extension:this.Extension,
                         
        }
       
        this.attachmentList.push(obj)
        console.log(" this.attachmentList", this.attachmentList)      
      
      }
   
    });
    
  }
  onClickDownloadForm(form) {

      var newstring = form.attachment_.slice(1);
      console.log('length ', newstring.length - 1)

      let _newstring = newstring.substring(0, newstring.length - 1);
      console.log("newstringnewstringnewstring", _newstring)

      var arrBuffer = this.base64ToArrayBuffer(form.attachment_);

      if(form.Extension =='pdf'){
        var blob = new Blob([arrBuffer], { type: 'application/pdf' });  
        var link = document.createElement('a');    
        link.href = window.URL.createObjectURL(blob);
        link.download = form.FileName + '.pdf';
        link.click();
      }
      else if(form.Extension =='xls'){
        var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });  
        var link = document.createElement('a');    
        link.href = window.URL.createObjectURL(blob);
        link.download = form.FileName + '.xls';
        link.click();
      }
      else if(form.Extension =='docx'){
        var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });  
        var link = document.createElement('a');    
        link.href = window.URL.createObjectURL(blob);
        link.download = form.FileName + '.docx';
        link.click();
      }
      else if(form.Extension =='png'){
        var blob = new Blob([arrBuffer], { type: 'image/png' });  
        var link = document.createElement('a');    
        link.href = window.URL.createObjectURL(blob);
        link.download = form.FileName + '.png';
        link.click();
      }

      else if(form.Extension =='jpg'){
        var blob = new Blob([arrBuffer], { type: 'image/jpg' });  
        var link = document.createElement('a');    
        link.href = window.URL.createObjectURL(blob);
        link.download = form.FileName + '.jpg';
        link.click();
      }

      else if(form.Extension =='txt'){
        var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });  
        var link = document.createElement('a');    
        link.href = window.URL.createObjectURL(blob);
        link.download = form.FileName + '.txt';
        link.click();
      }
  }

  base64ToArrayBuffer(base64) {
    console.log("base64", base64)
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  delete(i) {
    let array =[];
    array=this.attachmentList;  
    array.splice(i,1)  
    this.attachmentList=array            
 
   }
   saveProductImprovement(){


    if(this.isSavedEnable==true){
 
    if(this.Selectmodel.length<=0){  
      this._notify.error('Please Enter Build #')
      }
      else if(this.serialStart==""){
        this._notify.error('Please Enter Serial Start #')
      }
      else if(this.serialEnd==""){
        this._notify.error('Please Enter Serial End #')
      }
      else if(this.PIPNumber==""){
        this._notify.error('Please Enter PIP #')
      }
      else if(this.PIPHeading==""){
        this._notify.error('Please Enter PIP Heading')
      }
      else if(this.startDate==null){
        this._notify.error('Please Enter Start Date')
      }
      // else if(this.endDate==null){
      //   this._notify.error('Please Enter End Date')
      // }
      else if(this.selectStatus==0){
        this._notify.error('Please Enter PIP Status')
      }
        else if(this.isvalidateStartSerialnumber==false){
      this._notify.error('An error occurred please check the data')
    }
  
    else if(this.isvalidateEndSerialnumber==false){
      this._notify.error('An error occurred please check the data')
    }
    
      else{
        this.Selectmodel=this.Selectmodel_
    let model= new  PIPDetailsVM();
    model.SerialStart=this.serialStart;
    model.SerialEnd=this.serialEnd;
    model.PIPNo=this.PIPNumber;
    model.PIPHeading=this.PIPHeading;
    model.PIPDescription=this.PIPDescription;
    model.StartDate= new Date(this.startDate);
    model.EndDate=this.endDate !=null?new Date(this.endDate):null;
    model.PIPStatusID=this.selectStatus;
    model.supportProgramLevelId=this.supportProgramAssociateLevel
    model.supportProgramNote=this.supportProgramNotes;
    model.ModelId=this.Selectmodel
    model.currentDate=new Date();
    this._programImprovementService.addNewPIPDetails(model).subscribe(PIPId=>{
      if(PIPId>0)
      {
        this.isSavedEnable=false
        this._notify.success('Program Successfully Added');

        this.showGenerateButton=true
        this.NewProductProgramId=PIPId

        if(this.attachmentList.length>0){
          this._programImprovementService.addsupportDoc(this.attachmentList, PIPId).subscribe(res=>{
            if(res>0){
              this._notify.success('Support Doc Successfully Uploaded');
            }
  
          })
        }
      }
      else{
        
          this._notify.error('An error occurred please check the data');
        
      }
    })

 }
}
else{
  this._notify.error('An error occurred PIP already exists'); 
}
 }

   updateProdImprovement()
   {

let model =new PIPDetailsVM();
model.Id=this.ProductProgramId;
model.ModelId=this.Selectmodel;
model.SerialStart=this.serialStart;
model.SerialEnd=this.serialEnd;
model.PIPNo=this.PIPNumber;
model.PIPHeading=this.PIPHeading;
model.PIPDescription=this.PIPDescription;
model.supportProgramLevelId=this.supportProgramAssociateLevel
model.supportProgramNote=this.supportProgramNotes;
model.PIPStatusID=this.selectStatus;
model.StartDate= new Date(this.startDate);
model.EndDate= this.endDate !=null?new Date(this.endDate):null;

this._programImprovementService.updateProdImprovement(model).subscribe(res=>{
  console.log(res)
  if(res=true){
    console.log("ttttt")
  this._programImprovementService.updateSupportDocForPIP(this.attachmentList, this.ProductProgramId).subscribe(res=>{
   this._notify.success('Successfully Updated');
 })
}
  else{
    this._notify.error('An error occurred please check the data');
  }
  })

   }

  //  model = new FormControl("", [Validators.required]);
  //  getErrorMessage() {
  //    return this.model.hasError("required") ? "You must enter a value" : "";
  //  }

  ResetFields(){
    this.Selectmodel =[];
    this.startDate=null;
    this.endDate=null;
    this.serialStart="";
    this.serialEnd="";
    this.PIPNumber="";
    this.PIPHeading="";
    this.PIPDescription="";
    this.selectStatus=0;
   this.supportProgramAssociateLevel=0;
   this.supportProgramNotes="";
   this.attachmentList=[]
  
  }

  buildnoFormControl = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.buildnoFormControl.hasError("required") ? "You must enter a value" : "";
  }

  selectAll(ev) {
    let  arr=[]
     this.isSelectAll = !this.isSelectAll;
     if(this.isSelectAll){
       for(let i=0; i<this.modelList.length; i++){
         arr.push(this.modelList[i].ID)
       } 
          this.buildnoFormControl.setValue(arr);
     } 
     else{
       this.buildnoFormControl.setValue([]);
     }   
      console.log(this.buildnoFormControl.value);
      this.Selectmodel_=this.buildnoFormControl.value
   }
 
   
   valueChange(ID: number) {
    console.log(this.Selectmodel_.indexOf(ID));
    if (this.Selectmodel_.indexOf(ID) > -1) {
      const pos = this.Selectmodel_.indexOf(ID);
      this.Selectmodel_.splice(pos, 1);
    } else {
      this.Selectmodel_.push(ID);
    }
    console.log(this.Selectmodel_);
  }


  sendPIPNotificatinEmailtoUsers(){
    this._programImprovementService.sendPIPNotificatinEmailtoUsers(this.NewProductProgramId).subscribe(res=>{
      
if(res==true){
  this._notify.success('Successfully sent an email');

}
    })
  }

  sendPIPNotificatinEmailtoUsers_(){
    this._programImprovementService.sendPIPNotificatinEmailtoUsers(this.ProductProgramId).subscribe(res=>{
      
if(res==true){
  this._notify.success('Successfully sent an email');

}
    })
  }


    isvalidateStartSerialnumber:boolean=false
    isvalidateEndSerialnumber:boolean=false
    checkBuiltNoStart(event)
    {
      console.log(event.target.value.length)
     
      if(event.target.value !="" && event.target.value.length>3){    
        if (isNaN(event.target.value.slice(event.target.value.length - 4))) {
          console.log(event.target.value.slice(event.target.value.length - 4))
          
          this.isvalidateStartSerialnumber=false

        }else 
          this.isvalidateStartSerialnumber=true}
      else{
        this.isvalidateStartSerialnumber=false
       
      }  
      
    }

    checkBuiltNoEnd(event)
    {     
      console.log(event.target.value.length)
      if(event.target.value !="" && event.target.value.length>3){
      
        if (isNaN(event.target.value.slice(event.target.value.length - 4))) {
          console.log(event.target.value.slice(event.target.value.length - 4))
         
          this.isvalidateEndSerialnumber=false

        }else this.isvalidateEndSerialnumber=true
      }else{
        this.isvalidateEndSerialnumber=false 
       


      }  
    }

    NavigateToSearch(){
      this._router.navigate(['/product-improvement-program-search']);
      }
}
